const Visibility = Object.freeze({
  Hidden: 0,
  Visible: 1,
});

const local = "http://localhost:5000";
const local2 = "http://localhost:3000";
const live = "https://api.dreamlived.com";

const activeUserServer = live;

const SERVER_DOMAIN = activeUserServer;
// const SERVER_API_URL = 'https://2115.api.dreamlived.com';
const SERVER_API_URL = activeUserServer;
// const SERVER_API_URL = 'http://localhost:3000';
const MEDIA_SERVER_URL = "https://dreamapp.b-cdn.net";
// const MEDIA_SERVER_URL = "https://dpcst9y3un003.cloudfront.net";

export { Visibility, SERVER_API_URL, SERVER_DOMAIN, MEDIA_SERVER_URL };
